import Dashboard from './dashboard.js';
import { TITLES } from '../../shared/constants';
import InlineMessage from '../inline-message';
import { getUser } from '../../shared/auth-service';

const MainComponent = () => {
    const user = getUser();

    if (user && (!user.passwordChanged && !user.isRecoverPassword)) {

        // return (
        //     <InlineMessage message={TITLES.MESSAGE_CHANGE_PASSWORD_LINK} />
        //);

        return (
             <InlineMessage
                message={
                <>
                    Hemos enviado un correo con las instrucciones a la siguiente dirección: &nbsp;
                    <span style={{ 
                        fontWeight: 'bold',
                        display: 'inline-block',
                        maxWidth: '100%',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-all',
                        whiteSpace: 'normal',
                    }}>
                    {user.email}
                    </span>
                    &nbsp;Revisa tu bandeja de entrada y la carpeta de correo no deseado, para que asi puedas
                    realizar el cambio de clave obligatorio, ya que es tu primer ingreso.
                </>
                }
            />
        );

    }

    if (user && user.isRecoverPassword) {

        // return (
        //     <InlineMessage message={TITLES.MESSAGE_RECOVER_PASSWORD_LINK} />
        // );

        return (
             <InlineMessage
                message={
                <>
                    Hemos enviado un correo con las instrucciones a la siguiente dirección: &nbsp;
                    <span style={{ 
                        fontWeight: 'bold',
                        display: 'inline-block',
                        maxWidth: '100%',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-all',
                        whiteSpace: 'normal',
                    }}>
                    {user.email}
                    </span>
                    &nbsp;Revisa tu bandeja de entrada y la carpeta de correo no deseado.
                </>
                }
            />
        );
    }

    return (
        <Dashboard user={user} />
    );
}

export default MainComponent;
